<template>
  <div>
    <h5 class="title">{{$t('user.createwallet.imtokentip.title')}}</h5>
    <p class="tip">{{$t('user.createwallet.imtokentip.tip-1')}}</p>
    <p class="tip tip-bottom">{{$t('user.createwallet.imtokentip.tip-2')}}</p>
    <div class="token-list">
      <div class="token-item" v-for="(mnemonic,i) in mnemonic.mnemonic" :key="i">
        <div >{{mnemonic}}</div>
      </div>
    </div>
    <div class="icon-list">
      <div class="col-4 icon">
        <img class="icon-img" src="@/assets/image/red-1.png">
        <h5 class="icon-text">{{$t('user.createwallet.imtokentip.icon-tip1')}}</h5>
      </div>
      <div class="col-4 icon">
        <img class="icon-img" src="@/assets/image/red-2.png">
        <h5 class="icon-text">{{$t('user.createwallet.imtokentip.icon-tip2')}}</h5>
      </div>
      <div class="col-4 icon">
        <img class="icon-img" src="@/assets/image/red-3.png">
        <h5 class="icon-text">{{$t('user.createwallet.imtokentip.icon-tip3')}}</h5>
      </div>
    </div>
    <div class="icon-1">
      <img class="icon-1-img" src="../../../../assets/image/green.png">
      <h5 class="icon-1-text">{{$t('user.createwallet.imtokentip.icon-tip4')}}</h5>
    </div>
    <button class="blue-btn" @click="toPath('home')">{{$t('user.createwallet.imtokentip.next')}}</button>
  </div>
</template>
<script>
import {mapState} from "vuex";
export default {
  computed:{
    ...mapState("wallet",["mnemonic"])
  },
  methods:{
    toPath(name) {
      this.$router.push({name})
		}
  }
}
</script>
<style lang="scss" scoped>
  .title{
    font-size: 1.6rem;
    font-weight: bold;
    color: #333333;
    margin-bottom: 0.8rem;
  }
  .tip{
    font-size: 1.4rem;
    font-weight: 400;
    color: rgba(51,51,51,0.7);
  }
  .tip-bottom{
    padding-bottom: 1.2rem;
    border-bottom: 0.05rem solid #dedede;
    margin-bottom: 1.4rem;
  }
  .blue-btn{
    outline: none;
    width: 100%;
    height: 4.9rem;
    background: #DC472A;
    border-radius: 0.4rem;
    border: none;
    color: #ffffff;
    margin: 4rem 0 0 0 ;
  }
  .token-list{
    display: flex;
    flex-wrap: wrap;
    .token-item{
      padding: 0.4rem 0;
      text-align: center;
      font-size: 1.6rem;
      font-weight: 400;
      color: rgba(51,51,51,0.7);
      margin: 0 5% 1.2rem 0;
      min-width: 30%;
      height: 3.5rem;
      border-radius: 0.2rem;
      border: 0.1rem solid #E5E5E5;
      &:nth-child(3n){
        margin-right: 0;
      }
    }
  }
  .icon-list{
    border-bottom: 0.05rem solid #dedede;
    display: flex;
    flex-wrap: wrap;
    margin: 2.8rem 1.4rem 1.7rem 1.4rem;
    padding-bottom: 1.5rem;
    .icon{
      text-align: center;
      width: 30%;
      margin: 0 5% 0 0;
      &:nth-child(3){
        margin-right: 0;
      }
      .icon-img{
        width: 3.5rem;
        margin-bottom: 0.8rem;
      }
      .icon-text{
        font-size: 1.2rem;
        font-weight: 400;
        color: #333333;
      }
    }
  }
  .icon-1{
    text-align: center;
    .icon-1-img{
      width: 3.5rem;
      margin-bottom: 0.8rem;
      }
    .icon-1-text{
      font-size: 1.2rem;
      font-weight: 400;
      color: #333333;
    }
  }
@media screen and (max-width: 768px){
  .blue-btn{
    position: absolute;
    bottom: 4.1rem;
    transform: translateX(-50%);
    left: 50%;
    max-width: 96%;
  }
}
</style>